import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'supertokens-auth-react/recipe/session';

import { userApi } from 'src/Services/API';

export const useSignOut = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useCallback(async () => {
    try {
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();

        if (subscription) {
          await userApi.userControllerDeletePushSubscription({ endpoint: subscription.endpoint });

          await subscription.unsubscribe();
        }
      }
    } catch (error) {
      console.error('Could not unsubscribe from push notifications during logout.', error);
    }

    await signOut();
    queryClient.clear();
    navigate('/auth');
  }, [navigate, queryClient]);
};
